import userVerified from "../../media/undraw_agree_g19h.svg"
import userUnverified from "../../media/undraw_ai-answers_uxgx.svg"
import '../../css/userprofilesetting.css'
import usefbStore from "../../store/firebasestore"
import { useState, useRef,useEffect } from "react"
import Swal from "sweetalert2"
import { Icon } from "@iconify/react"
import { db, storage } from "../../firebase/firebase"
import "ldrs/react/Jelly.css";
import { getAuth,signOut,deleteUser } from "firebase/auth"
import { Jelly } from "ldrs/react";
import userImg from "../../media/user2.png"
import useStore from "../../store/zustandstore"
import { doc, updateDoc } from "firebase/firestore"
import userprofImg from "../../media/wave-haikei (3).svg"
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"
import solaraBadgeImg from "../../media/undraw_global-team_8jok.svg"
import axios from "axios"
import { DiditSdk } from "@didit-protocol/sdk-web";
import { useNavigate } from "react-router-dom"

function AccountStatus() {
    const accountVerified = usefbStore((s) => s.accountVerified)
    const userID = usefbStore((s) => s.userID)
    const userName = usefbStore((s) => s.userName)
    const userEmail = usefbStore((s) => s.userEmail)
    const accountPoints = usefbStore((s) => s.accountPoints)
    const region = usefbStore((s) => s.region)
    const realName = usefbStore((s) => s.realName)
    const navigate = useNavigate()
    const activeSince = usefbStore((s) => s.activeSince)
    const hideUserDashNav = useStore((s) => s.hideUserDashNav)
    const showUserDashboard = useStore((s) => s.showUserDashboard)
    const [step, setStep] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [userLevel, setUserLevel] = useState(null)

    
    // File states
    const [idFrontFile, setIdFrontFile] = useState(null)
    const [idBackFile, setIdBackFile] = useState(null)
    const [selfieFile, setSelfieFile] = useState(null)
    
    // Preview URLs
    const [idFrontPreview, setIdFrontPreview] = useState(null)
    const [idBackPreview, setIdBackPreview] = useState(null)
    const [selfiePreview, setSelfiePreview] = useState(null)
    
    // Extracted ID data
    const [extractedIdData, setExtractedIdData] = useState(null)
    
    // Hidden file inputs
    const idFrontInputRef = useRef(null)
    const idBackInputRef = useRef(null)
    const selfieInputRef = useRef(null)

    const toUserDash = () => {
        hideUserDashNav()
        showUserDashboard()
    }



  useEffect(() => {
    function getUserLevel(points) {
      if (points >= 4000) {
        setUserLevel("Pro")
      } else if (points >= 2000) {
        setUserLevel("Master")
      } else if (points >= 1000) {
        setUserLevel("Journeyman")
      } else {
        setUserLevel("Rookie")
      }
    }
    
    if (accountPoints !== undefined && accountPoints !== null) {
      getUserLevel(accountPoints)
    }
  }, [accountPoints])
    
   
const formatDate = (timestamp) => {
  const date = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);

  const day = date.getDate();

  const getOrdinal = (n) => {
    if (n > 10 && n < 20) return "th";

    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const month = date.toLocaleString("en-US", {
    month: "short",
  });

  const year = date.getFullYear();

  return ` ${month} ${day}, ${year}`;
};

    const toIDS = () => {
        setStep(1)
    }

    
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

useEffect(() => {
  DiditSdk.shared.onComplete = async (result) => {

    switch (result.type) {
    case "completed":
  setLoading(true);

  if (result.session?.sessionId) {
    try {
      const response = await fetch("https://solaraback-g1bm.onrender.com/verification-complete", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sessionId: result.session.sessionId,
          status: result.session.status,
          userId: userID,
          userEmail: userEmail,
          userName: userName,
        }),
      });

      const data = await response.json();
      
      // ✅ Show the backend's message
      if (data.verified) {
        Swal.fire({
          icon: "success",
          title: "Verification Approved",
          text: data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: data.message || "Identity verification failed.",
        });
      }
      
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to complete verification.",
      });
    } finally {
      setLoading(false);
    }
  }
  break;
      case "cancelled":
        setLoading(false);

        Swal.fire({
          icon: "warning",
          title: "Verification Cancelled",
          text: "You have cancelled the verification process.",
        });

        setStatus("cancelled");
        break;

      case "failed":
        setLoading(false);

        Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: "An error occurred during verification.",
        });

        console.error(
          "Verification failed:",
          result.error?.message
        );

        setStatus("failed");
        break;
    }
  };

  return () => {
    DiditSdk.shared.onComplete = undefined;
  };
}, [userID, userEmail, userName]);

  const startVerification = async () => {
    try {
      setLoading(true);
      setStatus("");

      // Ask YOUR backend to create a Didit session
      const response = await fetch("https://solaraback-g1bm.onrender.com/create-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: userID,
          userName: userName,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to create verification session");
      }

      const data = await response.json();


      // Start Didit
      DiditSdk.shared.startVerification({
        url: data.url,

        configuration: {
          loggingEnabled: true,
          showCloseButton: true,
          showExitConfirmation: false,
          closeModalOnComplete: true,
        },
      });

    } catch (error) {
      console.error(error);
      setStatus("Unable to start verification");
      setLoading(false);
    }
    
  };


const disableAccount = async () => {
    // First confirmation
    const result = await Swal.fire({
        title: "Delete Account Permanently?",
        text: "This action is irreversible. Your account will be permanently deleted and you will no longer be able to sign in.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Keep My Account",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6a5acd",
        reverseButtons: true
    });

    if (!result.isConfirmed) return;

    // Final confirmation
    const finalResult = await Swal.fire({
        title: "Final Confirmation",
        text: "Are you absolutely sure you want to permanently delete your account? This action cannot be undone.",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete Permanently",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6a5acd",
        reverseButtons: true
    });

    if (!finalResult.isConfirmed) return;

    try {
        const auth = getAuth();
        const user = auth.currentUser;

        if (!user) {
            await Swal.fire({
                title: "Error",
                text: "No authenticated user found.",
                icon: "error"
            });

            return;
        }

        // Loading dialog
        Swal.fire({
            title: "Deleting Account...",
            text: "Please wait while your account is permanently deleted.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        // Permanently delete Firebase Authentication account
        await deleteUser(user);

        // Clear local authentication session
        await signOut(auth);

        Swal.close();

        // Success message
        await Swal.fire({
            title: "Account Deleted",
            text: "Your account has been permanently deleted. You will no longer be able to sign in.",
            icon: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "#6a5acd",
            allowOutsideClick: false
        });

        navigate("/auth");

    } catch (error) {
        console.error("Account deletion error:", error);

        Swal.close();

        if (error.code === "auth/requires-recent-login") {
            await Swal.fire({
                title: "Sign-In Required",
                text: "For your security, please sign in again before permanently deleting your account.",
                icon: "warning",
                confirmButtonText: "OK",
                confirmButtonColor: "#6a5acd"
            });

            return;
        }

        await Swal.fire({
            title: "Deletion Failed",
            text: "We could not delete your account. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
            confirmButtonColor: "#6a5acd"
        });
    }
};
   

    return (
        <div className="accStatus">
            <div className="accStatusWrap">
                <div className="accStatusWrapMini">
                    {!accountVerified ? (
                        <div className="unverifiedAcc">
                            {step === 0 && (
                                <>
                                    <img src={userUnverified} alt="Not verified icon" />
                                    <span>Verify Your Account</span>
                                    <p>Verify your account now to unlock full access 
                                        and start working on tasks. It only takes a few minutes.
                                    </p>
                                    <div className="metamapBtn">
                                        { loading ? (<Jelly
                                  size="45"
                                  speed="1"
                                  color="#6a5acd" 
                                ></Jelly>):( <button
                                            className="metamapBtnAct"     
                                            onClick={startVerification}
 >
                                            Verify Me
                                        </button>) }
                                         
                                       
                                    
                                    </div>    
                                </>
                            )}
                        </div>
                    ) : (
                        <>
                        <div className="vrfAcc">
                            <div className="verifiedWrap">
                                <div className="vrTop">
                                                                              <p className="accStatusCard">Active</p> 

                                    <div className="vrTopUserLeft">
                                        <div className="vtulr">
                                            <p className="accUserNameLevel">Your account is</p>
                                            <p className="accUserName">Verified</p>

                            
                                        </div>
                                    </div>
                                    <div className="vrTopUserRight">
                                        <img src={userprofImg} alt="" />
                                      
                                    </div>

                                </div>
                                <div className="vrBtm">
                                    <div className="vrBtmClmn">
                                        <p>Account Level</p>
                                        <p>{userLevel}</p>
                                    </div>
                                    <div className="vrBtmClmn">
                                        <p>Since</p>
                                        <p>{formatDate(activeSince)}</p>
                                    </div>
                                    <div className="vrBtmClmn">
                                        <p>State/Region</p>
                                        <p>{region}</p>
                                    </div>
                                    <div className="vrBtmClmn">
                                        <p>Status</p>
                                        <p>Active</p>
                                    </div>
                                    <div className="vrBtmClmnTerminate" onClick={disableAccount}>
                                        <p>Terminate Account</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AccountStatus